import "babel-polyfill";

import React from "react";
import ReactDOM from "react-dom";

import "jquery";
import "jquery-ui-bundle";

import "bootstrap";
import "@fortawesome/fontawesome-pro/css/fontawesome.min.css";

import App from "@/modules/common/app/containers/app.container";

import "@common/components/alert/alert";

import { Provider } from "react-redux";
import store, { importReducers } from "@common/store/store";

import { setSagas, setCommonSagas } from "@common/store/saga";

import Context from "@common/store/context";

import { setMenu } from "@common/menu/menu";
import { setRoutes } from "@common/router/router";
import { setBreadcrumb } from "@common/breadcrumb/breadcrumb";

import { menu } from "./menu.config";
import { routes, reducers, sagas, breadcrumbs } from "@/import";

import CommonSagas from "@common/externos/store/sagaImports";

import sessionUtil from "@common/helpers/sessionStorage.utils";

setMenu(menu);
setRoutes(routes);
importReducers(reducers);
setCommonSagas(CommonSagas);
setSagas(sagas);
setBreadcrumb(breadcrumbs);

sessionUtil.setItem("SISTEMA", 21);
sessionUtil.setItem("isExterno", true);

ReactDOM.render(
  <Provider context={Context} store={store}>
    <App />
  </Provider>,
  document.getElementById("app")
);

$(function () {
  $('[data-toggle="tooltip"]').tooltip({
    container: "body",
  });
});
